import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';

//
// actionTypes
//
const SHOW = 'DBM/UI/MAIN_MENU/SHOW';
const HIDE = 'DBM/UI/MAIN_MENU/HIDE';

//
// Create actions
//
const show = createAction(SHOW);
const hide = createAction(HIDE);


export const actionTypes = {
    SHOW,
    HIDE
};

export const actions = {
    show,
    hide
};

//
// Export reducer
//
export const reducer = handleActions({
    [system.INIT]: () => (state) => state.setIn(['ui', 'stickyHeaderVisibility'], false),
    [SHOW]: () => (state) => state.setIn(['ui', 'stickyHeaderVisibility'], true),
    [HIDE]: () => (state) => state.setIn(['ui', 'stickyHeaderVisibility'], false)
});

const isVisible = (state) => state.getIn(['ui', 'stickyHeaderVisibility']);

export const selectors = {
    isVisible
};
